import { ModuleTree } from "vuex";
import { RootState } from "@/store/types";
import paymentPackages from "./paymentPackages";

export const modules: ModuleTree<RootState> = {
  paymentPackages,
};

export default modules;
